import React from "react";
import { ProgressBar } from "@shopify/polaris";
import styles from "./UploadGridItem.module.css";

const UploadingDocument = (props: any) => (
    <div className={props.selectedStyle}>
        <div className={styles.container}>
            <div className={styles.UploadStateText}>
                <b> Uploading Document </b>
            </div>
            <ProgressBar progress={props.uploadProgress} size={"small"} />
        </div>
    </div>
);
export default UploadingDocument;
